import { TAttachment, TIdentificationRequestPrefill, TSendMessagePayload } from '@/models/chat.model';
import { IUser } from '@/models/user.model';
import { createContext, ReactNode, useContext } from "react";

export type TButton = {
  text: string;
  action: string;
  sessionId: string;
  userId: string;
  role?: string;
};

export type TSocketContext = {
  messages: IMessage[];
  buttons: TButton[];
  isTyping: boolean;
  isBot: boolean;
  shareContacts: boolean;
  userInfo: TIdentificationRequestPrefill | null;
  isSharingContacts: boolean;
  setShowShareContacts: (value: boolean) => void;
  onCancelShareContacts: () => void;
  setUser: (user: IUser) => void;
  onDisconnect: () => void;
  onSendMessage: (data: TSendMessagePayload) => void;
  sendMessage: (text: string) => void;
  setButtons: React.Dispatch<React.SetStateAction<TButton[]>>;
  setMessages: React.Dispatch<React.SetStateAction<IMessage[]>>;
  onSendRate: (rate: string, isBot: boolean, sessionId: string, userId: string) => void;
  ref?: React.RefObject<HTMLDivElement | null>;
};

export interface ChatConfig {
  baseUrl: string;
  token: string;
  userId: string;
}

export interface IMessage {
  id: string;
  sender?: string;
  isHistory?: boolean;
  type?: string;
  sessionId?: string;
  message: ReactNode;
  date?: Date | string;
  messageType?: string;
  attachments?: TAttachment[];
}

export const SocketContext = createContext<TSocketContext | null>(null);

export const useSocket = () => {
  const socket = useContext(SocketContext);

  if (!socket) {
    throw new Error("useSocket must be used within a SocketProvider");
  }

  return socket;
};
